import React, { Fragment, useState, useEffect, useCallback } from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import { Steps } from "./steps";
import StepperEvent from "../../StepperEvent";
import { Progress } from "reactstrap";
import { ShipmentRepository } from "../../../repositories";

export const ShipmentDetail = (props) => {
  const shipment = props.shipment.length !== 0 ? props.shipment[0] : []
  const [newSteps, setNewSteps] = useState([]);

  /*const trackIcon = {
    Aerea:
      "https://fsposeidon.blob.core.windows.net/roldan/ICONOGRAFIA_ROL4LL_TRANSPORT_RGB-08.png",
    Maritima:
      "https://fsposeidon.blob.core.windows.net/roldan/ICONOGRAFIA_ROL4LL_TRANSPORT_RGB-01.png",
    Terrestre:
      "https://fsposeidon.blob.core.windows.net/roldan/ICONOGRAFIA_ROL4LL_TRANSPORT_RGB-02.png",
  };*/
  const trackIcon = {
    Aerea:
      "https://magiclog.blob.core.windows.net/onboardpic/air_shipment.png",
    Maritima:
      "https://magiclog.blob.core.windows.net/onboardpic/sea_shipment.png",
    Terrestre:
      "https://magiclog.blob.core.windows.net/onboardpic/road_shipment.png"
  };

  const fetchData = useCallback(async () => {
    // let url = `${Services.Shipments.path}trazabilidad/shipmentevents/${shipment.ShipmentId}?lang=EN`
    // let getSteps = await Axios.get(url);
    const getSteps = await ShipmentRepository.getEvents(shipment.ShipmentId);

    let update = false;
    for (let index = getSteps.steps.length; index >= 0; index--) {
      const element = getSteps.steps[index];
      if (element && element.completed) update = true;
      if (update) element.completed = true;
    }

    let newSteps = Steps;
    let dataEvents = getSteps.data;
    var findNext = false;
    newSteps.map((f) => {
      dataEvents.map((e) => {
        if (e.EventDescriptionId === f.id) {
          findNext = true;
          f.value = e.EventDate;
          if (e.InTimeLine === "1") {
            f.completed = true;
          } else {
            findNext = false;
          }
        } else {
          findNext = false;
        }
        if (findNext) {
          f.completed = true;
        }
        return e;
      });
      return f;
    });
    newSteps.sort(function (a, b) {
      return b.order - a.order;
    });
    let findTrue = false;

    newSteps.map((e) => {
      if (e.completed) {
        findTrue = true;
      }
      if (findTrue) {
        e.completed = true;
      }
      return e;
    });

    newSteps.sort(function (a, b) {
      return a.order - b.order;
    });

    newSteps.sort(function (a, b) {
      return a.order - b.order;
    });

    setNewSteps(newSteps);
  }, [shipment])

  useEffect(() => {
    if (shipment.length !== 0) {
      fetchData();
    }
  }, [shipment]);

  return (
    <Fragment>
      <Card className="myCard">
        <CardBody>
          <Col xs={12}>
            <div className="row pb-1">
              <div className="col-6">
                <span className="linkCard">{shipment.length !== 0 ? shipment.ShipmentNumber : '---'}</span>
                <br />
              </div>
              <div className="col-6 d-flex justify-content-end">
                <span className="title-custom-value">Update date: <span className="tag-custom-value">{`${shipment.length !== 0 ? shipment.UpdateDate : '---'}` + ` (${shipment.length !== 0 ? shipment.timezone : '---'})`}</span></span>
              </div>
            </div>
            <Row>
              <Col xs={12} md={5} lg={3} className="d-flex align-items-center pr-0">
                <div className="col-4 row">
                  {/* <div className="col-4 justify-content-center row"> */}
                  <div>
                    {shipment.length !== 0 ? shipment.TransportMode ? (
                      <img
                        alt=""
                        src={
                          shipment.TransportMode === "Air"
                            ? trackIcon.Aerea
                            : shipment.TransportMode === "Sea"
                              ? trackIcon.Maritima
                              : trackIcon.Terrestre
                        }
                        width="45"
                        height="45"
                      ></img>
                    ) : (
                      <></>
                    ) : '---'
                    }
                  </div>
                  <div>
                    <span className="title-custom-value">{shipment.length !== 0 ? shipment.Status : '-----'}</span>
                  </div>
                </div>
                <Col className="col-8">
                  <div>
                    <Progress
                      color={"success"}
                      value={shipment.length !== 0 ? shipment.Progress : ''}
                    />
                    {/* {shipment.PriorityShipment === "Si" || shipment.PriorityShipment === "Yes" ?
                      <img src={priorityShipmentURL}
                        width="25px" height="25px"
                        title={this.props.t("prioritary_shipment")}
                        style={{ marginLeft: "15px" }}
                      />
                      : ""} */}
                    {/* </div> */}
                  </div>
                  {/* <div>
                    {shipment.Invoice ?
                      <div className="mt-4">
                        <span
                          // style={{ marginRight: ".5vw" }} 
                          className="title-custom-value mr-1">Invoiced</span>
                        <input
                          id="check-obl"
                          type="checkbox"
                          // title={this.props.t("invoiced")}
                          checked
                        // disabled
                        >
                        </input>
                      </div>
                      : false
                    }
                  </div> */}
                </Col>
              </Col>
              <Col xs={12} md={7} lg={9} className="pl-0">
                <StepperEvent steps={newSteps} />
              </Col>
            </Row>
          </Col>
        </CardBody>
      </Card>
    </Fragment>
  );
};
